import Config from '../config'
import Ajax from './ajax'


var CartApi = {};

CartApi.addToCart = function (jsonData) {

    logToCentralServer("CartApi.addToCart() adding to cart started", jsonData, 1);

	return new Promise ( function (resolve, reject) {

		var cartId = CartApi._makeGuid();

		Ajax.put({
			url: Config.EditorGatewayApi + '/v1/prints/cart/' + cartId + '?t=' + Date.now(),
			responseType: 'JSON',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: jsonData,
			retry: { //Sometimes the images are not yet quite ready, and we get an error. Retry a couple of times rather than just fail.
				times: 10,
				waitTimeBetweenRetries: 2000,
				regexMatchResponse:  /Following master images/
			}
		}).then(function (response) {
            logToCentralServer("CartApi.addToCart() added to cart", response, 1);
			resolve(response.cartId);
		}).catch(function (error) {
            logToCentralServer("CartApi.addToCart() failed to add", error, 3);
			reject({message: _('Unable to add to cart'), cartId: cartId, error: error});
		});
	});
};

CartApi.getStatus = function (cartId) {
	return new Promise(function (resolve, reject) {
		Ajax.get({
			url: Config.EditorGatewayApi + '/v1/prints/cart/' + cartId + '?t=' + Date.now(),
			responseType: 'JSON'
		}).then(function (res) {
            logToCentralServer("CartApi.getStatus()", res, 1);
			resolve(res);
		}).catch(function (error) {
            logToCentralServer("CartApi.getStatus() error", error, 3);
            reject({message: _('Unable to add to cart'), cartId: cartId, error: error});
		});
	});
};

CartApi._makeGuid = function () {
   	function S4() {
   		return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
   	}
 	var guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
 	return guid;
};

export default CartApi;
